import { TodoListId, isTodoFolderList, isTodoMyDayList } from 'owa-todo-list-types';
import { assertNever } from 'owa-assert';
import type { ListSort } from 'owa-todo-utils';

export function getListSort(listId: TodoListId): ListSort {
    if (isTodoMyDayList(listId)) {
        return 'CommittedOrder';
    } else if (isTodoFolderList(listId)) {
        return 'OrderDateTime';
    }
    return assertNever(listId);
}
